const mapContainer = document.querySelector('[data-map-operations]')
const popins = document.querySelectorAll('[data-map-popin]')
const popinTriggers = document.querySelectorAll('[data-open-popin]')
const popinClosers = document.querySelectorAll('[data-close-popin]')
const popinToggleClass = 'is-active'

let lastFocusedElement = null

const MapOperations = {
	init: () => {
		if (!mapContainer) return
		MapOperations.handlePopins()
		MapOperations.initMap("map-operations", {
			scrollWheelZoom: false,
		})
	},

	initMap: (mapId, mapOptions) => {
		if (!mapContainer) return
		const map = L.map(mapId, mapOptions).setView([48.8490929, 2.3697692], 12)
		const useClustering = false
        // scrollWheelZoom : false, // Désactive le zoom avec la molette de la souris

        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_2dhc_1_97399d99711bf629faf85cb6', {
            maxZoom: 19,
            attribution: '&copy; OpenStreetMap contributors',
        }).addTo(map)

		// Si operations_map est défini et contient des données, on ajoute les marqueurs sur la carte
		if (typeof operations_map !== 'undefined' && Array.isArray(operations_map)) {
			const markersLayer = useClustering ? L.markerClusterGroup() : L.layerGroup()
			const markersByStatus = {}

			operations_map.forEach((operation) => {
				if (operation.lat && operation.lng) {
					const icon = L.icon({
						iconUrl: operation.icon,
						iconSize: [46, 55],
						iconAnchor: [23, 55],
						popupAnchor: [0, -55],
					})
					const marker = L.marker([operation.lat, operation.lng], { icon })
					// AU clic ça affiche la popin correspondante
					marker.on('click', () => {
						const popin = document.querySelector(`#operation-${operation.id}`)
						if (popin) {
							MapOperations.openPopin(popin)
						}
					})
					markersLayer.addLayer(marker)
					if (!markersByStatus[operation.status]) markersByStatus[operation.status] = []
					markersByStatus[operation.status].push(marker)
				}
			})
			map.addLayer(markersLayer)
			MapOperations.handleFilters(map, markersLayer, markersByStatus)
		}
	},

	handleFilters: (map, markersLayer, markersByStatus) => {
		const filterButtons = document.querySelectorAll('[data-map-filter]')
		if (!filterButtons.length) return

		filterButtons.forEach((btn) => {
			btn.addEventListener('click', () => {
				btn.classList.toggle('is-active')

				const activeFilters = [...filterButtons]
					.filter((b) => b.classList.contains('is-active'))
					.map((b) => b.dataset.mapFilter)

				markersLayer.clearLayers()

				const statusesToShow = activeFilters.length
					? activeFilters
					: Object.keys(markersByStatus)

				statusesToShow.forEach((status) => {
					;(markersByStatus[status] ?? []).forEach((marker) => {
						markersLayer.addLayer(marker)
					})
				})
			})
		})
	},


	handlePopins: () => {
		if (!popinTriggers.length && !popinClosers.length) return

		document.addEventListener('click', (e) => {
			popinTriggers.forEach((trigger) => {
				if (trigger.contains(e.target)) {
					e.preventDefault()
					if (trigger.dataset.openPopin) {
						lastFocusedElement = trigger
						const popin = document.querySelector(trigger.dataset.openPopin)
						MapOperations.openPopin(popin)
					}
				}
			})
			popinClosers.forEach((closer) => {
				if (closer.contains(e.target)) {
					MapOperations.closePopins()
				}
			})
		})

		document.addEventListener('keydown', (e) => {
			if (e.key !== 'Escape') return
			const activePopin = document.querySelector(`[data-map-popin].${popinToggleClass}`)
			if (activePopin) MapOperations.closePopins()
		})
	},

	openPopin: (popin) => {
		if (!popins.length) return
		if (!popin) throw `MapOperations@openPopin : popin introuvable`
		MapOperations.closePopins()
		const img = popin.querySelector('img[data-src]')
		if (img) {
			img.src = img.dataset.src
			if (img.dataset.srcset) img.srcset = img.dataset.srcset
			if (img.dataset.sizes) img.sizes = img.dataset.sizes
			img.removeAttribute('data-src')
			img.removeAttribute('data-srcset')
			img.removeAttribute('data-sizes')
		}
		popin.querySelectorAll('[tabindex="-1"]').forEach((el) => {
			el.tabIndex = 0
		})
		popin.classList.add(popinToggleClass)

		if (popin._transitionHandler) {
			popin.removeEventListener('transitionend', popin._transitionHandler)
		}
		popin._transitionHandler = () => {
			delete popin._transitionHandler
			const firstFocusable = popin.querySelector('[tabindex="0"]')
			;(firstFocusable ?? popin).focus()
			MapOperations.trapFocus(popin)
		}
		popin.addEventListener('transitionend', popin._transitionHandler, { once: true })
	},

	closePopins: () => {
		popins.forEach((popin) => {
			if (popin._trapFocusHandler) {
				popin.removeEventListener('keydown', popin._trapFocusHandler)
				delete popin._trapFocusHandler
			}
			popin.querySelectorAll('[tabindex="0"]').forEach((el) => {
				el.tabIndex = -1
			})
			if (!popin.classList.contains(popinToggleClass)) return
			popin.classList.remove(popinToggleClass)

			if (popin._transitionHandler) {
				popin.removeEventListener('transitionend', popin._transitionHandler)
			}
			popin._transitionHandler = () => {
				delete popin._transitionHandler
				const stillOpen = document.querySelector(`[data-map-popin].${popinToggleClass}`)
				if (!stillOpen && lastFocusedElement) {
					lastFocusedElement.focus()
					lastFocusedElement = null
				}
			}
			popin.addEventListener('transitionend', popin._transitionHandler, { once: true })
		})
	},

	trapFocus: (popin) => {
		popin._trapFocusHandler = (e) => {
			if (e.key !== 'Tab') return
			const focusables = [...popin.querySelectorAll('[tabindex="0"]')]
			if (!focusables.length) return
			const first = focusables[0]
			const last = focusables[focusables.length - 1]
			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault()
				last.focus()
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault()
				first.focus()
			}
		}
		popin.addEventListener('keydown', popin._trapFocusHandler)
	},
}

export default MapOperations
